import React from 'react';
import { marketplaceIconFor } from '../config/brandIcons';
import { storeLabelForId } from '../lib/storeHelpers';
import BrandIcon from './BrandIcon';

const StoreLabel = ({ id, stores = [], size = 18 }) => {
  const store = stores.find(s => s.id === id);
  const label = storeLabelForId(id, stores);
  return (
    <span className="d-inline-flex align-items-center gap-2">
      <BrandIcon
        src={marketplaceIconFor(
          store?.marketplaceName,
          store?.storeName || label
        )}
        alt={`${label}${
          store?.marketplaceName ? ` (${store.marketplaceName})` : ''
        }`}
        size={size}
      />
      <span>{label}</span>
    </span>
  );
};
export default StoreLabel;
